class BotController {
  constructor(gameInterface, botId, gameState) {
    this.gameInterface = gameInterface;
    this.botId = botId;
    this.gameState = gameState;
    this.updateInterval = setInterval(() => this.update(), 200); // Reduced frequency
    this.targetZone = null;
    // Initialize with default values to avoid undefined errors
    this.avoidanceDirection = { dx: 0, dy: 0 };
  }

  update() {
    try {
      const bot = this.gameState.entities[this.botId];
      if (!bot || !bot.isAlive || this.gameState.isGameOver) {
        return;
      }

      // Find a target if we don't have one or occasionally reconsider
      if (!this.targetZone || !this.isTargetValid(this.targetZone, bot) || Math.random() < 0.05) {
        this.targetZone = this.findBestTarget(bot);
      }

      let dx = 0;
      let dy = 0;

      // If we have a target, move toward it
      if (this.targetZone) {
        const directionToTarget = this.getDirectionToTarget(bot, this.targetZone);
        dx = directionToTarget.dx;
        dy = directionToTarget.dy;
      } else {
        // Random movement if no target
        dx = Math.random() * 2 - 1;
        dy = Math.random() * 2 - 1;
      }

      // Normalize the direction vector
      const magnitude = Math.sqrt(dx * dx + dy * dy);
      if (magnitude > 0) {
        dx /= magnitude;
        dy /= magnitude;
      }

      // Ensure dx and dy are valid numbers
      dx = isNaN(dx) ? 0 : dx;
      dy = isNaN(dy) ? 0 : dy;

      // Clamp values to ensure they're within valid range
      dx = Math.max(-1, Math.min(1, dx));
      dy = Math.max(-1, Math.min(1, dy));

      // Send the movement event
      this.gameInterface.sendGameEvent('joystick_move', {
        userId: this.botId,
        dx,
        dy
      });
    } catch (error) {
      console.error("Error in BotController update:", error);
    }
  }

  findBestTarget(bot) {
    const activeZones = this.gameState.colorZones.filter(zone => zone.active);
    
    // First priority: zones matching the bot's current color
    const matchingZones = activeZones.filter(zone => zone.color === bot.currentColor);
    
    if (matchingZones.length > 0) {
      // Find the closest matching zone
      return this.findClosestZone(bot, matchingZones);
    }
    
    // If no matching zones, return null
    return null;
  }

  findClosestZone(bot, zones) {
    let closestZone = null;
    let closestDistance = Infinity;
    
    zones.forEach(zone => {
      const distance = Math.sqrt(
        Math.pow(bot.x - zone.x, 2) + 
        Math.pow(bot.y - zone.y, 2)
      );
      
      if (distance < closestDistance) {
        closestDistance = distance;
        closestZone = zone;
      }
    });
    
    return closestZone;
  }

  getDirectionToTarget(bot, target) {
    const dx = target.x - bot.x;
    const dy = target.y - bot.y;
    
    // Normalize the direction vector
    const magnitude = Math.sqrt(dx * dx + dy * dy);
    if (magnitude > 0) {
      return {
        dx: dx / magnitude,
        dy: dy / magnitude
      };
    }
    
    return { dx: 0, dy: 0 };
  }

  isTargetValid(zone, bot) {
    return zone.active && zone.color === bot.currentColor;
  }

  destroy() {
    clearInterval(this.updateInterval);
  }
}

export default BotController;
